export const VTFullscreenBackIcon = 'https://res.cloudinary.com/pineapple-labs/image/upload/v1648438211/virtual-tour/back-white_dazmbl.svg';
export const VTFullscreenForwardIcon = 'https://res.cloudinary.com/pineapple-labs/image/upload/v1648438211/virtual-tour/forward-white_kqbseb.svg';
